import {GET} from "@/services/gateway";

const getEnableSpecialFolders = () => {
  return GET(`exchange/mail/enable-special-folders`, )
}

export {
  getEnableSpecialFolders,
}
